import React from "react";
import { Link } from "react-router-dom";

import Divider from "./divider";

function SettingsNav() {
  const activeSetting =
    document.location.href.split("/")[
      document.location.href.split("/").length - 1
    ];

  return (
    <>
      <div className="settings_menu">
        <h4 className="my-3">Settings</h4>
        <Divider
          style={{
            position: "relative",
            left: 0,
            marginBottom: 16,
            height: 2,
            marginRight: 4,
          }}
        />

        <ul>
          <div className="sidemenu">
            <li className="nav-item">
              <Link
                to={"/org/settings/company"}
                className={
                  "nav-link " + (activeSetting === "company" ? "active" : "")
                }
              >
                <i className="la la-briefcase"></i>
                <span>Company</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to={"/org/settings/team"}
                className={
                  "nav-link " + (activeSetting === "team" ? "active" : "")
                }
              >
                <i className="la la-user-friends"></i>
                <span>Manage Team</span>
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link
                to={"/org/settings/bank"}
                className={
                  "nav-link " + (activeSetting === "bank" ? "active" : "")
                }
              >
                <i className="la la-piggy-bank"></i>
                <span>Connect Bank</span>
              </Link>
            </li> */}
          </div>
        </ul>
      </div>
    </>
  );
}

export default SettingsNav;
